import React, { useState, useEffect, useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';

import styles from './styles.module.css';
// import { AdminContext } from '../../../context/AdminContext';

const CustomSelect = ({
  list,
  title,

  fillFormFunction,
  error,

  value = '',
  children,

  extraButtonStyle = '',
  extraWrapperStyle='',
}) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(0);

  const [optionsList, setOptionsList] = useState([]);
  const {themeMode, direction} = useContext(AdminContext)
  // const { themeMode, direction } = useContext(AdminContext);

  useEffect(() => {
    setOptionsList([...[{ id: '', faName: 'انتخاب کنید' }].concat(list)]);
  }, [list]);
  useEffect(() => {
    if (value?.length !== 0 && optionsList.length !== 0) {
      const initalIndex = optionsList.findIndex((x) => x?.id == value);

      setSelectedOption(initalIndex);
    }
  }, [optionsList, value]);

  const toggleOptions = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };

  const setSelectedThenCloseDropdown = (index) => {
    if (index !== 0) {
      setSelectedOption(index);

      fillFormFunction(optionsList[index]?.id);
      setIsOptionsOpen(false);
    }
  };

  const handleKeyDown = (index) => (e) => {
    if (index !== 0) {
      switch (e.key) {
        case ' ':
        case 'SpaceBar':
        case 'Enter':
          e.preventDefault();
          setSelectedThenCloseDropdown(index);
          break;
        default:
          break;
      }
    }
  };

  const handleListKeyDown = (e) => {
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        setIsOptionsOpen(false);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedOption(
          selectedOption - 1 >= 0 ? selectedOption - 1 : optionsList.length - 1
        );
        break;
      case 'ArrowDown':
        e.preventDefault();
        setSelectedOption(
          selectedOption == optionsList.length - 1 ? 0 : selectedOption + 1
        );
        break;
      default:
        break;
    }
  };

  return (
    <div className={`${styles.wrapper} ${extraWrapperStyle}`}>
      <div className={styles.container}>
        <div
          className={`flex flex-row justify-between items-center w-full h-auto mb-[4px]`}
        >
          <p className={styles.titleStyle}>{title}</p>
          {children && <div>{children}</div>}
        </div>
        <button
          type='button'
          aria-haspopup='listbox'
          aria-expanded={isOptionsOpen}
          className={`${styles.buttonSelect} ${direction=="ltr" && styles.ltr} ${extraButtonStyle} notcenter ${
            error && styles.yellowBorder
          }  selectButton ${isOptionsOpen ? styles.expanded : ''}`}
          onClick={toggleOptions}
          onKeyDown={handleListKeyDown}
        >
          {optionsList[selectedOption]?.faName
            ? optionsList[selectedOption]?.faName
            : optionsList[selectedOption]?.uuName}
        </button>
        <ul
          className={`${styles.options} ${
            themeMode != 'white' && 'borderBlack'
          } ${styles.ul} selectedOption ${
            themeMode != 'white' ? 'dark' : 'light'
          } ${isOptionsOpen ? `${styles.show}` : ''}`}
          role='listbox'
          aria-activedescendant={optionsList[selectedOption]?.faName}
          tabIndex={-1}
          onKeyDown={handleListKeyDown}
        >
          {optionsList?.map((option, index) => (
            <li
              className={index == 0 ? styles.disabled : styles.li}
              id={index}
              key={index}
              role='option'
              aria-selected={selectedOption == index}
              tabIndex={0}
              onKeyDown={handleKeyDown(index)}
              onClick={() => {
                setSelectedThenCloseDropdown(index);
              }}
            >
              {option?.faName ? option?.faName : option?.uuName}
            </li>
          ))}
        </ul>
        {error && (
          <p className={`${styles.inputError} preserveWhitethemeMode`}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
};
export default CustomSelect;
